class ChildForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))    
    this.childID = this.form.getAttribute('data-child-id') || null
    this.inputs = this.querySelectorAll('input, textarea, select');
    this.original_values = this.getValues()
    this.actionsContainer = this.querySelector('.customer-club__form--actions')
    this.editContainer = this.querySelector('.customer-club__form--edit')

    this.editButton = this.querySelector('[data-edit]')
    this.editButton.addEventListener('click', this.edit.bind(this))
    
    this.deleteButton = this.querySelector('[data-delete]')
    this.deleteButton.addEventListener('click', this.handleDelete.bind(this))

    this.cancelButton = this.querySelector('[data-cancel]')
    this.cancelButton.addEventListener('click', this.view.bind(this))

    this.autosize(this.inputs[0])
  }

  async handleDelete() {
    this.actionsContainer.querySelector('.loader').hidden = false

    await fetch(`/apps/customer-club/customer/child/remove`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ child: {id: this.childID}})
    }).then(async(res) => {
      if (res.status >= 400 && res.status < 600) {
        const err = await res.json();
        throw new Error(err.message || err.statusText);
      }

      this.dispatchEvent(
        new CustomEvent("child:removed", {
          bubbles: true
        })
      );

      return this.remove()
    })
  }

  autosize(textarea, row_limit) {
    row_limit = parseInt(row_limit ?? '5');
    if (!row_limit) {
      row_limit = 5;
    }
  
    textarea.style.setProperty('resize', 'none');
    textarea.style.setProperty('min-height', '0');
    textarea.style.setProperty('max-height', 'none');
    textarea.style.setProperty('height', 'auto');
  
    textarea.oninput = function() {
      textarea.setAttribute('rows', '1');
  
      const cs = getComputedStyle(textarea);
      const inline_padding = parseFloat(cs['padding-left']) + parseFloat(cs['padding-right']);
      const inline_border_width = parseFloat(cs['border-left-width']) + parseFloat(cs['border-right-width']);
      textarea.style.setProperty('overflow', 'hidden', 'important');
      textarea.style.setProperty('width', (parseFloat(cs['width']) - inline_padding - inline_border_width) + 'px');
      textarea.style.setProperty('box-sizing', 'content-box');
      textarea.style.setProperty('padding-inline', '0');
      textarea.style.setProperty('border-width', '0');
      
      const block_padding = parseFloat(cs['padding-top']) + parseFloat(cs['padding-bottom']);
      const line_height = cs['line-height'] === 'normal' 
        ? parseFloat(cs['height'])
        : parseFloat(cs['line-height']);
  
      const scroll_height = Math.round(textarea.scrollHeight);
  
      textarea.style.removeProperty('width');
      textarea.style.removeProperty('box-sizing');
      textarea.style.removeProperty('padding-inline');
      textarea.style.removeProperty('border-width');
      textarea.style.removeProperty('overflow');
  
      const rows = Math.round((scroll_height - block_padding) / line_height);
      textarea.setAttribute("rows", "" + Math.min(rows, row_limit));
    };
  
    textarea.dispatchEvent(new Event('input', {
      bubbles: true
    }));
  }

  view() {
    if(this.childID === null) {
      this.dispatchEvent(
        new CustomEvent("child:removed", {
          bubbles: true
        })
      );
      return this.remove();
    };
    
    this.inputs.forEach((input, index) => {
      input.setAttribute('disabled', 'disabled')
      input.value = this.original_values[index].value
    })

    this.editContainer.hidden = true
    this.actionsContainer.hidden = false
  }

  edit() {
    this.inputs.forEach(input => {
      input.removeAttribute('disabled')
    })

    this.inputs[0].focus();
    this.editContainer.hidden = false
    this.actionsContainer.hidden = true
  }

  getValues() {
    return Array.from(this.inputs).map(input => { 
      return {
        input: input, 
        value: input.value 
      }
    });
  }

  async onSubmitHandler(event) {
    event.preventDefault();

    const formData = new FormData(this.form)
    const sanitizedChildName = formData.get('child_name').replace(/\s/gm," ");
    const formattedChild = {
      ...(this.childID !== null && {id: this.childID}),
      first_name: sanitizedChildName.split(" ")[0],
      last_name: sanitizedChildName.split(" ").slice(1).join(' '),
      gender: formData.get(`child_gender`),
      relation: formData.get(`child_relation`),
      birthdate: formData.get(`child_birthdate`)
    }

    this.inputs.forEach(input => {
      input.setAttribute('disabled', 'disabled')
    })

    this.editContainer.querySelector('.loader').hidden = false

    await fetch(`/apps/customer-club/customer/child/${this.childID === null ? 'add' : 'update'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ child: formattedChild})
    }).then(async(res) => {
      if (res.status >= 400 && res.status < 600) {
        const err = await res.json();
        throw new Error(err.message || err.statusText);
      }

      return await res.json()
    }).then(data => {
      if (this.childID === null) this.childID = data.id
      this.editContainer.querySelector('.loader').hidden = true
      this.original_values = this.getValues()
      this.view()
    })
  }
}

customElements.define("child-form", ChildForm);

class ChildSection extends HTMLElement {
  constructor() {
    super();
    this.childTemplate = null
    this.fetchChildTemplate()

    this.addChildButton = this.querySelector('[data-add-child]')
    this.addChildButton.addEventListener('click', this.handleAddChild.bind(this))
    
    this.list = this.querySelector('#children-list')
    this.counter = this.addChildButton.querySelector('[data-count]')

    this.addEventListener('child:removed', (event) => this.updateCounters(event))
  }

  async fetchChildTemplate() {
    const url = `${window.Shopify.routes.root}?view=child_form`
    await fetch(url)
      .then(res => res.text())
      .then(text => {
        const template = document.createElement('template');
        template.innerHTML = text
        this.childTemplate = template.content;
      })
  }

  updateCounters(event) {
    this.childForms = Array.from(this.list.querySelectorAll('child-form'))

    if(event !== undefined) this.childForms.splice(this.childForms.indexOf(event.target), 1)

    this.childForms.forEach((form, index) => {
      form.querySelector('[data-count]').innerText = index + 1
    })

    this.counter.innerText = this.childForms.length + 1
  }

  handleAddChild() {
    if (this.childTemplate !== null ) {
      const newChild = this.childTemplate.cloneNode(true)
      this.list.appendChild(newChild)
      this.updateCounters()
    }
  }
}

customElements.define("child-section", ChildSection);